import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ForwardRates from './pages/ForwardRates';
import Alerts from './pages/Alerts';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import BottomNav from './components/BottomNav';
import './App.css';

const GOOGLE_CLIENT_ID =
  '389151961632-mjjm15kqanvpkeaosqp0to2i86rsf0qf.apps.googleusercontent.com';

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login"    element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={
              <PrivateRoute>
                <Dashboard />
                <BottomNav active="rates" />
              </PrivateRoute>
            } />
            <Route path="/forward" element={
              <PrivateRoute>
                <ForwardRates />
                <BottomNav active="forward" />
              </PrivateRoute>
            } />
            <Route path="/alerts" element={
              <PrivateRoute>
                <Alerts />
                <BottomNav active="alerts" />
              </PrivateRoute>
            } />
            <Route path="/profile" element={
              <PrivateRoute>
                <Profile />
                <BottomNav active="profile" />
              </PrivateRoute>
            } />
            <Route path="/admin" element={
              <AdminRoute>
                <AdminPanel />
                <BottomNav active="profile" />
              </AdminRoute>
            } />
            <Route path="/"  element={<Navigate to="/login" replace />} />
            <Route path="*"  element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;